import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import MarketplaceTeam from "marketplace/teams/team";
import React from "react";
import Marketplace from "work/work-agreements/teams/vendor-team/_views/marketplace/vendor-marketplace";

const PageContainer = styled(Box)(() => ({
  display: 'grid',
  gridTemplateRows: "auto 1fr",
  width: "100%"
}));
const TabsContainer = styled("div")(() => ({
  gridRowStart: 1
}));
const TabContent = styled("div")(() => ({
  gridRowStart: 2,
  gridRowEnd: 'none'
}));

type VendorTeamSelectionProps = {
  searchParams?: URLSearchParams;
  onNewSelection: (team: MarketplaceTeam) => void;
  closeDialog: () => void;
};

export default function VendorTeamSelection(props: Readonly<VendorTeamSelectionProps>) {
  const { searchParams, onNewSelection } = props;

  const [activeTab, setActiveTab] = React.useState("marketplace");

  return (
    <PageContainer>
      <TabsContainer>
        <Tabs
          indicatorColor="primary"
          variant="scrollable"
          value={activeTab}
          onChange={(event, tab) => setActiveTab(tab)}
          aria-label="Team selection nav">
          <Tab value="marketplace" label="Marketplace" />
        </Tabs>
      </TabsContainer>
      {activeTab === "marketplace" && (
        <TabContent>
          <Marketplace
            selectingTeam={true}
            searchParams={searchParams}
            onTeamSelected={onNewSelection}
          />
        </TabContent>
      )}
    </PageContainer>
  );
}
